var moment = require("moment");
require("../datepicker");

var module = angular.module("app.directives");

module.directive("date", function() {
	return {
		restrict: "E",
		scope: {
			picker: "=?",
			min: "@?",
			max: "@?"
		},
		replace: true,
		require: "ngModel",
		template: require("./date.pug"),
		link: function(scope, element, attrs, ngModel) {
			scope.$watch(
				"min",
				validator(
					scope,
					"min",
					function(min, value) {
						return moment(value, "YYYY-MM-DD").isSameOrAfter(
							moment(min, "YYYY-MM-DD")
						);
					},
					ngModel
				)
			);

			scope.$watch(
				"max",
				validator(
					scope,
					"max",
					function(max, value) {
						return moment(value, "YYYY-MM-DD").isSameOrBefore(
							moment(max, "YYYY-MM-DD")
						);
					},
					ngModel
				)
			);

			scope.min = scope.min || "1753-01-01";
			scope.max = scope.max || "2099-12-31";

			if (attrs.$attr.future) {
				scope.min = moment().format("YYYY-MM-DD");
			}

			if (attrs.$attr.past) {
				scope.max = moment().format("YYYY-MM-DD");
			}

			scope.onChange = function() {
				ngModel.$setViewValue(scope.model.format("YYYY-MM-DD"));
				ngModel.$render();
			};

			ngModel.$render = function() {
				var val = ngModel.$viewValue;
				scope.model = val ? moment(val, "YYYY-MM-DD") : null;
			};
		}
	};
});

module.directive("time", function() {
	return {
		restrict: "E",
		scope: {
			picker: "=?",
			min: "@?",
			max: "@?"
		},
		require: "ngModel",
		replace: true,
		template: require("./time.pug"),
		link: function(scope, element, attrs, ngModel) {
			scope.onChange = function() {
				ngModel.$setViewValue(scope.model.format("HH:mm"));
				ngModel.$render();
			};

			ngModel.$render = function() {
				var val = ngModel.$viewValue;
				scope.model = val ? moment(val, "HH:mm") : null;
			};
		}
	};
});

module.directive("datetime", function() {
	return {
		restrict: "E",
		scope: {
			picker: "=?",
			min: "@?",
			max: "@?"
		},
		require: "ngModel",
		replace: true,
		template: require("./datetime.pug"),
		link: function(scope, element, attrs, ngModel) {
			scope.$watch(
				"min",
				validator(
					scope,
					"min",
					function(min, value) {
						return moment(value).isSameOrAfter(moment(min));
					},
					ngModel
				)
			);

			scope.$watch(
				"max",
				validator(
					scope,
					"max",
					function(max, value) {
						return moment(value).isSameOrBefore(moment(max));
					},
					ngModel
				)
			);

			scope.min = scope.min || "1753-01-01";
			scope.max = scope.max || "2099-12-31";

			if (attrs.$attr.future) {
				scope.min = moment().format();
			}

			if (attrs.$attr.past) {
				scope.max = moment().format();
			}

			scope.onChange = function() {
				ngModel.$setViewValue(parse(scope.model.utc().format()));
				ngModel.$render();
			};

			ngModel.$render = function() {
				var val = ngModel.$viewValue;
				scope.model = val ? moment(parse(val)) : null;
			};
		}
	};
});

function validator(scope, key, fn, ngModel) {
	return function(watchValue) {
		scope[key + "dp"] = watchValue ? moment(watchValue) : null;
		if (!watchValue) {
			delete ngModel.$validators[key];
			return;
		}
		ngModel.$validators[key] = function(validatorValue) {
			if (!validatorValue) return true;
			return fn(watchValue, validatorValue);
		};
		ngModel.$validate();
	};
}

function parse(input) {
	if (moment.isMoment(input)) return input;
	input = input.replace("+00:00", "Z");
	if (input.length > 10 && input.slice(-1) != "Z") {
		input += "Z";
	}
	return input;
}
